import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Breadcrumbs from '../Breadcrumbs';

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const Layout = ({ children }) => {
  return (
    <LayoutWrapper>
      <Navbar />
      <Breadcrumbs />
      <MainContent>
        {children}
      </MainContent>
      <Footer />
    </LayoutWrapper>
  );
};

export default Layout; 